window.addEventListener('load', frd_create_elements);
window.addEventListener('load', frd_default_store_block);
window.addEventListener('load', frd_delivery_method_tabs);
window.addEventListener('load', frd_variant_listener);
window.addEventListener('load', frd_quantity_listener);

/**
 * Create elements
 */
function frd_create_elements() {
  const delivery_methods_section = document.querySelector('section[frd-delivery-methods]');
  
  if(!delivery_methods_section) {
    return;
  }

  // Wait for the payment button to render (it loads after a short delay)
  // We are already in a window "load" handler (see top of file), so we only need a timeout here.
  setTimeout(() => {
    const shopify_payment_button = document.querySelector('.shopify-payment-button');

    console.log('shopify_payment_button: ', shopify_payment_button);
    if (shopify_payment_button) {
      shopify_payment_button.insertAdjacentElement('afterend', delivery_methods_section);
    }
  }, 2000);

}

/**
 * Tabs
 */
function frd_delivery_method_tabs() {
  const delivery_tab = document.querySelector('ul[frd-delivery-method-tabs] li [frd-delivery-tab]');
  const delivery_content_once = document.querySelector('div[frd-delivery-method="delivery-once"]');
  //const delivery_content_subscribe = document.querySelector('div[frd-delivery-method="delivery-subscribe"]');
  const pickup_tab = document.querySelector('ul[frd-delivery-method-tabs] li [frd-pickup-tab]');
  const pickup_content = document.querySelector('div[frd-delivery-method="pickup"]');

  // Delivery tab
  delivery_tab.addEventListener('click', async (event) => {
    // If error exists (from previous change)
    let error_paragraph = document.querySelector('.error');
    let add_to_cart_button = document.querySelector(add_to_cart_button_selector);

    if(error_paragraph) {
      // Remove error
      error_paragraph.remove();

      // Enable "Add to Cart" button
      if(add_to_cart_button) {
        add_to_cart_button.disabled = false;
      }
    }
    
    // Add attributes from Delivery button
    delivery_tab.classList.add('active');
    delivery_tab.setAttribute('disabled', true);
    delivery_tab.setAttribute('aria-disabled', true);

    delivery_content_once.style.display = 'block';
    //delivery_content_subscribe.style.display = 'block';

    // Remove attributes to Pickup button
    pickup_tab.classList.remove('active');
    pickup_tab.removeAttribute('disabled');
    pickup_tab.removeAttribute('aria-disabled');

    pickup_content.style.display = 'none';

    // Quantity check (will restore button text since pickup is not active)
    frd_quantity_check();

    // Update variant options (will use global inventory since pickup is not active)
    if(typeof syncOptionsToVariant === 'function') {
      syncOptionsToVariant().catch(err => console.warn('Error syncing options:', err));
    }

    // Update property input value
    frd_pickup_input_check();
  });

  // Pickup tab
  pickup_tab.addEventListener('click', async (event) => {
    // If error exists (from previous change)
    let error_paragraph = document.querySelector('.error');
    let add_to_cart_button = document.querySelector(add_to_cart_button_selector);

    if(error_paragraph) {
      // Remove error
      error_paragraph.remove();
      
      // Enable "Add to Cart" button
      if(add_to_cart_button) {
        add_to_cart_button.disabled = false;
      }
    }

    // Add attributes to Pickup button
    pickup_tab.classList.add('active');
    pickup_tab.setAttribute('disabled', true);
    pickup_tab.setAttribute('aria-disabled', true);

    pickup_content.style.display = 'block';

    // Remove attributes from Delivery button
    delivery_tab.classList.remove('active');
    delivery_tab.removeAttribute('disabled');
    delivery_tab.removeAttribute('aria-disabled');

    delivery_content_once.style.display = 'none';

    // Quantity check
    frd_quantity_check();

    // Update variant options based on store inventory
    if(typeof syncOptionsToVariant === 'function') {
      syncOptionsToVariant().catch(err => console.warn('Error syncing options:', err));
    }

    // Clear property input value
    let store_name = document.querySelector('div[frd-delivery-method] span.store-name').textContent;

    frd_pickup_input_check(store_name);
  });
}

/**
 * Variant listener
 */
function frd_variant_listener() {
  const options = document.querySelectorAll('.latest-option');
  
  options.forEach((option) => {
    option.addEventListener('click', async (event) => {
      const lightbox_button = document.querySelector('button[frd-stores-lightbox][frd-variant-id]');
      const url_parameters = new URLSearchParams(window.location.search);
      const variant_id = Number(url_parameters.get('variant'));

      // Set store block
      let selected_store = await frd_default_store_block();

      // Update "Choose a Store" button variant ID attribute
      if(lightbox_button) {
        lightbox_button.setAttribute('frd-variant-id', variant_id);
      }

      // Quantity check
      frd_quantity_check();

      // Update variant options based on store inventory (if pickup is active)
      const pickup_tab = document.querySelector('[frd-pickup-tab]');
      if(pickup_tab && pickup_tab.classList.contains('active') && typeof syncOptionsToVariant === 'function') {
        syncOptionsToVariant().catch(err => console.warn('Error syncing options:', err));
      }
    });
  });
}

/**
 * Quantity listener
 */
function frd_quantity_listener() {
  const quantity_input = document.querySelector('input[name="quantity"]');
  
  observeElement(quantity_input, 'value', function(old_value, new_value) {
    frd_quantity_check();
  });
}

/**
 * Quantity check
 */
function frd_quantity_check(new_value = null) {
  const my_mho_store_id = localStorage.getItem('my_mho_store_id');
  const quantity_input = document.querySelector('input[name="quantity"]');

  if(new_value === null) {
    new_value = quantity_input.value;
  }

  const pickup_tab = document.querySelector('[frd-pickup-tab]');
  const quantity = Number(new_value);
  const store_inventory_span = document.querySelector('div[frd-delivery-method] span.store-inventory');
  const store_inventory = store_inventory_span ? Number(store_inventory_span.textContent.split(' ', 1)[0]) : 0;
  const delivery_methods_section = document.querySelector('section[frd-delivery-methods]');
  const error_paragraph = delivery_methods_section.querySelector('.error');
  let add_to_cart_button = document.querySelector(add_to_cart_button_selector);
  
  // Get button text attributes from masterselect (same as render.js)
  const masterselect = document.querySelector("#masterselect");
  const availabletext = masterselect ? masterselect.getAttribute("data-available-text") : null;
  const soldouttext = masterselect ? masterselect.getAttribute("data-solout-text") : null;

  // If error exists (from previous change)
  if(error_paragraph) {
    // Remove error
    error_paragraph.remove();

    // Enable "Add to Cart" button
    if(add_to_cart_button) {
      add_to_cart_button.disabled = false;
    }
  }

  // If "Pickup" is not selected
  if(!pickup_tab.classList.contains('active')) {
    // If switching to delivery, restore button text to available text
    if(add_to_cart_button && availabletext) {
      add_to_cart_button.innerHTML = availabletext;
      add_to_cart_button.disabled = false;
    }
    return;
  }

  // If no store is chosen
  if(!my_mho_store_id) {
    document.querySelector('div[frd-delivery-method] span.store-name').textContent = 'Choose a store to see available inventory.';
    return;
  }
  
  // If store is chosen, check inventory and update button accordingly
  if(my_mho_store_id && add_to_cart_button) {
    // Check if store inventory is 0 or quantity requested exceeds inventory
    if(store_inventory === 0 || quantity > store_inventory) {
      // Show error message if quantity exceeds inventory
      if(quantity > store_inventory && store_inventory > 0) {
        if(!error_paragraph) {
          delivery_methods_section.insertAdjacentHTML('afterbegin', `<p class="error">This store has ${store_inventory} available.</p>`);
        }
      }
      
      // Disable "Add to Cart" button and update text to sold out
      add_to_cart_button.disabled = true;
      if(soldouttext) {
        add_to_cart_button.innerHTML = soldouttext;
      }
    } else {
      // Store has inventory and quantity is available - enable button and show available text
      add_to_cart_button.disabled = false;
      if(availabletext) {
        add_to_cart_button.innerHTML = availabletext;
      }
    }
  }
}

/**
 * Observe element
 */
function observeElement(element, property, callback, delay = 0) {
  let elementPrototype = Object.getPrototypeOf(element);

  if (elementPrototype.hasOwnProperty(property)) {
    let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);

    Object.defineProperty(element, property, {
      get: function() {
        return descriptor.get.apply(this, arguments);
      },
      set: function () {
        let oldValue = this[property];

        descriptor.set.apply(this, arguments);

        let newValue = this[property];

        if(typeof callback == "function") {
          setTimeout(callback.bind(this, oldValue, newValue), delay);
        }

        return newValue;
      }
    });
  }
}

/**
 * Get stores for variant
 */
async function frd_get_variant_stores(product_id = null, variant_id = null) {
  // If product_id does not exist
  if(product_id === null || typeof product_id !== 'number') {
    return;
  }

  // If variant_id does not exist
  /*if(variant_id === null || typeof variant_id !== 'number') {
    return;
  }*/
  
  // Get stores from Product with GraphQL query
  const query = product_id => `
    query ProductFRDStores {
      node(id: "gid://shopify/Product/${product_id}") {
        ... on Product {
          id
          title
          metafield(namespace: "custom", key: "frd_stores") {
            value
            id
          }
        }
      }
    }
  `;

  // Get stores from Variant with GraphQL query
  /*const query = variant_id => `
    query ProductVariantFRDStores {
      node(id: "gid://shopify/ProductVariant/${variant_id}") {
        ... on ProductVariant {
          id
          title
          metafield(namespace: "custom", key: "frd_stores") {
            value
            id
          }
        }
      }
    }
  `;*/

  // Post options
  const options = {
    method: "post",
    headers: {
      "Content-Type": "application/graphql",
      "X-Shopify-Storefront-Access-Token": "2bf56fa5901b71fac0720e84333eea25"
    },
    body: query(product_id)
  };

  // Fetch
  const response = await fetch('https://mountainhighoutfitters.myshopify.com/api/2024-04/graphql.json', options);
  const result = await response.json();
  const product_stores_metafield = result.data.node.metafield;

  // If metafield does not exist
  if(!product_stores_metafield) {
    return null;
  }

  // Parse JSON
  const product_stores = JSON.parse(product_stores_metafield.value);
  const variant_stores = product_stores.filter(function(product) {
    return Number(product.variant_id) === variant_id;
  });

  // Return stores
  return JSON.stringify(variant_stores);
}

/**
 * Get selected store
 */
function frd_get_selected_store(store_id = null, stores = null) {
  // If store_id does not exist or store_id is not a number or stores does not exist
  if(store_id === null || stores === null) {
    return;
  }

  // String to object
  //stores = JSON.parse(stores);

  // Filter stores
  const store = stores.filter(function(store) {
    return store.id == store_id;
  });
  
  // Return
  return store[0];
}

/**
 * Default store block
 */
async function frd_default_store_block() {
  const my_mho_store_id = localStorage.getItem('my_mho_store_id');
  let url_parameters = new URLSearchParams(window.location.search);
  let product_id = Number(document.querySelector('[frd-product-id]').getAttribute('frd-product-id'));
  let variant_id = Number(url_parameters.get('variant'));
  let variant_stores = await frd_get_variant_stores(product_id, variant_id);

  // If no set store
  if(!my_mho_store_id) {
    return;
  }

  // String to object
  variant_stores = JSON.parse(variant_stores);

  // Get store
  let selected_store = frd_get_selected_store(my_mho_store_id, variant_stores);
  
  // If variant_stores does not exist
  if(variant_stores === null) {
    return;
  }

  // Get full store information (including address) from FRDStores
  if(typeof FRDStores !== 'undefined' && FRDStores.get_store) {
    const full_store = await FRDStores.get_store(my_mho_store_id);
    if(full_store) {
      // Merge full store info with variant store info
      selected_store = Object.assign({}, selected_store, {
        title: full_store.title,
        address: full_store.address,
        email: full_store.email,
        phone: full_store.phone,
        url: full_store.url
      });
    }
  }

  // Update store block
  frd_update_store_block(selected_store);

  // Return selected store
  return selected_store;
}

/**
 * Update store block
 */
function frd_update_store_block(store = null) {
  // If store_id does not exist
  if(store === null) {
    return;
  }

  let store_name_span = document.querySelector('div[frd-delivery-method] span.store-name');
  let store_inventory_span = document.querySelector('div[frd-delivery-method] span.store-inventory');

  store_name_span.textContent = store.title;
  store_inventory_span.textContent = `${store.inventory} in stock`;

  // Update delivery description address
  const delivery_description_address = document.querySelector('.delivery__description--address');
  if(delivery_description_address && store.address) {
    // Replace <br> tags with spaces for display
    const address_text = store.address.replace(/<br\s*\/?>/gi, ', ');
    delivery_description_address.textContent = address_text;
  }
  
  // Update button text based on store inventory (only if pickup tab is active)
  const pickup_tab = document.querySelector('[frd-pickup-tab]');
  if(pickup_tab && pickup_tab.classList.contains('active')) {
    frd_quantity_check();
    
    // Update variant options based on store inventory
    if(typeof syncOptionsToVariant === 'function') {
      syncOptionsToVariant();
    }
  }
}

/**
 * Get store inventory for a specific variant
 * Returns the inventory quantity at the selected store for the given variant, or null if not found
 */
async function frd_get_variant_store_inventory(variant_id, store_id) {
  if(!variant_id || !store_id) {
    return null;
  }

  try {
    const product_id = Number(document.querySelector('[frd-product-id]').getAttribute('frd-product-id'));
    if(!product_id) {
      return null;
    }

    const variant_stores_json = await frd_get_variant_stores(product_id, variant_id);
    if(!variant_stores_json) {
      return null;
    }

    const variant_stores = JSON.parse(variant_stores_json);
    const store = variant_stores.find(s => s.id == store_id);
    
    return store ? (store.inventory || 0) : null;
  } catch(error) {
    console.warn('[frd-stores] Error getting variant store inventory:', error);
    return null;
  }
}

/**
 * Get all variant store inventories for the current product and store
 * Returns a map of variant_id -> inventory_quantity
 */
async function frd_get_all_variant_store_inventories(store_id) {
  if(!store_id) {
    return {};
  }

  const inventoryMap = {};
  
  try {
    const product_id = Number(document.querySelector('[frd-product-id]').getAttribute('frd-product-id'));
    if(!product_id) {
      return {};
    }

    // Get all variants from masterselect
    const masterselect = document.querySelector("#masterselect");
    if(!masterselect) {
      return {};
    }

    const variantOptions = masterselect.querySelectorAll("option");
    const variantIds = Array.from(variantOptions).map(opt => Number(opt.value)).filter(Boolean);

    // Fetch inventory for each variant
    for(const variant_id of variantIds) {
      const inventory = await frd_get_variant_store_inventory(variant_id, store_id);
      if(inventory !== null) {
        inventoryMap[variant_id] = inventory;
      }
    }
  } catch(error) {
    console.warn('[frd-stores] Error getting all variant store inventories:', error);
  }

  return inventoryMap;
}

/**
 * Pickup input check
 */
function frd_pickup_input_check(store_name = null) {
  const store_id = localStorage.getItem('my_mho_store_id');
  const delivery_methods_section = document.querySelector('section[frd-delivery-methods]');
  const delivery_selected = document.querySelector('[frd-delivery-tab].active');
  let pickup_input = document.querySelector('input[name="properties[Shipping]"]');
  let pickup_location_input = document.querySelector('input[name="properties[Location]"]');

  // If input does not exist and delivery is selected
  if(!pickup_input && store_name && delivery_selected === null) {
    // Insert element
    delivery_methods_section.insertAdjacentHTML('afterbegin', `
      <input id="pickup" name="properties[Shipping]" type="hidden" value="Pick Up In-Store at ${store_name}">
      <input id="pickup-location" name="properties[Location]" type="hidden" value="${store_id}">`
    );
  }

  // If input and store name exists and delivery is selected
  if(pickup_input && store_name && delivery_selected === null) {
    pickup_input.value = `Pick Up In-Store at ${store_name}`;
    pickup_location_input.value = store_id;
  }

  // If input exists and store name does not exist
  if(pickup_input && store_name === null || store_name === null) {
    pickup_input.value = 'Ship to Home';
    pickup_location_input.value = '';
  }
}
